import Uri from "jsuri";
import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import {
  RequestMiddleware,
  mergeRequestMiddleware,
  mergeRequestUtilConfigs,
  RequestMiddlewareActions,
} from "./RequestUtil";
import { CancelTokenMidleware } from "./CancelTokenMidleware";
import { Fetcher } from "./fetchers";

type Url = string | Uri;

export function toUrl(url: Url) {
  return url instanceof Uri ? url.toString() : (url as string);
}

export function getRequest<
  ResponseData = any,
  Response extends AxiosResponse = AxiosResponse<ResponseData>
>(
  url: string,
  config: AxiosRequestConfig,
  fetcher: Fetcher,
  middleware: RequestMiddleware[] = []
) {
  type SourceUtilActions = RequestMiddlewareActions<
    ReturnType<typeof CancelTokenMidleware>
  >;

  const { preRequest, postRequest, actions, hooks, onError } =
    mergeRequestMiddleware<SourceUtilActions>(middleware);

  const makeRequest = async (requestUrl = url, requestConfig = config): Promise<Response> => {
    preRequest();
    try {
      const response = await fetcher<ResponseData, Response>(requestUrl, {
        ...requestConfig,
        ...mergeRequestUtilConfigs(middleware)
      });
      postRequest();
      return response;
    } catch (error) {
      if (!axios.isCancel(error)) onError(error);
      throw error;
    }
  };

  const response = {
    makeRequest,
    setUrl(newUrl: string) {
      url = newUrl;
    },
    hooks
  };

  return {
    ...actions,
    ...response
  };
}
